import i18n from 'locales/i18n';

export const getCurrentLanguage = () => {
  return i18n.language === 'ar' ? i18n.language : 'en'
}